import React from "react";
import PropTypes from "prop-types";
import { Table } from "react-bootstrap";
import styled, { css } from "styled-components";

const Container = styled.div`
  min-width: 100%;
  max-width: 100%;
  padding: 25px 32px 56px;
  margin-bottom: 33px;
  background: #ffffff;
  box-shadow: 0px 3px 25px rgba(168, 168, 168, 0.3);
`;
const Title = styled.h1`
  font-weight: bold;
  font-size: 18px;
  line-height: 47px;
  color: #7b848d;
  ${({ theme: { mobile } }) =>
    mobile &&
    css`
      font-size: 16px;
    `}
`;
const TableHeader = styled.thead`
  height: 42px;
`;
const TableHeaderRow = styled.tr`
  vertical-align: middle;
  border-top: 1px solid #ecedf1;
  border-bottom: 1px solid #ecedf1;
`;
const TableHeaderCell = styled.th`
  text-align: center;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 15px;
  color: #7b848d;
  white-space: nowrap;
  ${({ mwidth }) => (mwidth ? `max-width: ${mwidth}px !important` : "")}
`;
const TableHeaderCellLeft = styled(TableHeaderCell)`
  text-align: left;
`;
const TableBody = styled.tbody`
  border: none !important;
`;
const TableBodyRow = styled(TableHeaderRow)`
  border-top: none;
  height: 40px;
  ${({ index }) => (index % 2 === 0 ? "background-color: #FAFAFF;" : "")}
`;
const TableBodyCell = styled.td`
  text-align: center;
  font-style: normal;
  font-size: 12px;
  white-space: nowrap;
  color: ${({ color }) => color || "#394149"};
`;
const TableBodyCellLeft = styled(TableBodyCell)`
  text-align: left;
`;
const EmptyMessage = styled.div`
  color: #7b848d;
  font-weight: bold;
  text-align: center;
`;

function TableRow({ index, term, websiteURL }) {
  return (
    <TableBodyRow index={index}>
      <TableBodyCellLeft>{term}</TableBodyCellLeft>
      <TableBodyCellLeft>{websiteURL}</TableBodyCellLeft>
    </TableBodyRow>
  );
}

TableRow.propTypes = {
  index: PropTypes.number,
  term: PropTypes.string,
  websiteURL: PropTypes.string,
};

function CommonLawResultsDesktop({ commonLawResults }) {
  if (!commonLawResults) return null;

  return (
    <Container>
      <Title>Common Law Results</Title>
      {commonLawResults.length ? (
        <Table responsive>
          <TableHeader>
            <TableHeaderRow>
              <TableHeaderCellLeft>TERM</TableHeaderCellLeft>
              <TableHeaderCellLeft>WEBSITE URL</TableHeaderCellLeft>
            </TableHeaderRow>
          </TableHeader>
          <TableBody>
            {commonLawResults.map((commonLawInfo, idx) => (
              <TableRow key={idx} index={idx} {...commonLawInfo} />
            ))}
          </TableBody>
        </Table>
      ) : (
        <EmptyMessage>No conflicting Common Law results found</EmptyMessage>
      )}
    </Container>
  );
}

CommonLawResultsDesktop.propTypes = {
  commonLawResults: PropTypes.arrayOf(PropTypes.object),
};

export default CommonLawResultsDesktop;
